"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PerUnit = exports.Amount = exports.Title = exports.ComposedDetail = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var clsx_1 = __importDefault(require("clsx"));

var titleDefaultProps = {
  variant: 'body',
  weight: 'medium',
  align: 'center'
};
var amountDefaultProps = {
  variant: 'large',
  weight: 'bold',
  align: 'center'
};
var perUnitDefaultProps = {
  variant: 'body',
  weight: 'regular',
  align: 'center'
};
var defaultClasses = 'mb-0';
var defaultDisplay = 'col p-3';

exports.ComposedDetail = function (_a) {
  var className = _a.className,
      children = _a.children;
  return react_1.default.createElement("div", {
    className: clsx_1.default(defaultDisplay, className)
  }, children);
};

exports.Title = function (_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return react_1.default.createElement(react_theme_components_1.SzTypographie, __assign({}, titleDefaultProps, props, {
    className: clsx_1.default(defaultClasses, className)
  }), children);
};

exports.Amount = function (_a) {
  if (_a === void 0) {
    _a = amountDefaultProps;
  }

  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return react_1.default.createElement(react_theme_components_1.SzTypographie, __assign({}, amountDefaultProps, props, {
    className: clsx_1.default(defaultClasses, className)
  }), children);
};

exports.PerUnit = function (_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return react_1.default.createElement(react_theme_components_1.SzTypographie, __assign({}, perUnitDefaultProps, props, {
    className: clsx_1.default(defaultClasses, className)
  }), children);
};

exports.ComposedDetail.Title = exports.Title;
exports.ComposedDetail.Amount = exports.Amount;
exports.ComposedDetail.PerUnit = exports.PerUnit;
exports.default = exports.ComposedDetail;